import { render } from "./VueModal.vue?vue&type=template&id=4d3fdc74&scoped=true"
import script from "./VueModal.vue?vue&type=script&lang=js"
export * from "./VueModal.vue?vue&type=script&lang=js"

import "./VueModal.vue?vue&type=style&index=0&id=4d3fdc74&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3fdc74"]])

export default __exports__